import { NormalizedConditions } from '../types'

// eslint-disable-next-line complexity
export const withDefaultValues = (
  conditions: Partial<NormalizedConditions>
): NormalizedConditions => ({
  ...conditions,
  additionalQueries: conditions.additionalQueries ?? [],
  age: conditions.age ?? {},
  height: conditions.height ?? {},
  month: conditions.month ?? {},
  brandIds: conditions.brandIds ?? [],
  shopIds: conditions.shopIds ?? [],
  tagIds: conditions.tagIds ?? [],
  gender: conditions.gender ?? 'all',
  snapItems: conditions.snapItems ?? [],
  sort: conditions.sort ?? 'popular',
  userType: conditions.userType ?? 'all',
})
